import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Offer } from '../../../services/offerService';

interface LiveOffersManagementCardProps {
  offers: Offer[];
  onRefresh: () => void;
}

const LiveOffersManagementCard: React.FC<LiveOffersManagementCardProps> = ({ 
  offers 
}) => {
  const navigate = useNavigate();

  const handleViewAllOffers = () => {
    // Scroll to offers table
    const offersTable = document.querySelector('[data-offers-table]');
    if (offersTable) {
      offersTable.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-6 shadow-sm">
      {/* Quick Actions */}
      <div className="mb-4">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <Button
            variant="outline"
            onClick={() => navigate('/create-offer')}
            className="flex items-center justify-center space-x-2 h-10"
          >
            <Icon name="Plus" size={16} />
            <span className="text-sm">New Offer</span>
          </Button>
          
          <Button
            variant="outline"
            onClick={handleViewAllOffers}
            className="flex items-center justify-center space-x-2 h-10"
          >
            <Icon name="List" size={16} />
            <span className="text-sm">View All</span>
          </Button>
          
          <Button
            variant="outline"
            onClick={() => {
              // Focus on metrics cards to show current stats
              document.querySelector('[data-metrics-cards]')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex items-center justify-center space-x-2 h-10"
          >
            <Icon name="BarChart3" size={16} />
            <span className="text-sm">Analytics</span>
          </Button>
        </div>
      </div>

      {/* Enhanced Stats Summary */}
      <div className="p-3 bg-background rounded-lg border border-border">
        <div className="grid grid-cols-4 gap-4 text-center">
          <div>
            <div className="text-lg font-semibold text-foreground">
              {offers.filter(o => o.status === 'active').length}
            </div>
            <div className="text-xs text-muted-foreground">Active</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-foreground">
              {offers.filter(o => o.status === 'inactive').length}
            </div>
            <div className="text-xs text-muted-foreground">Inactive</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-foreground">
              {offers.filter(o => o.status === 'expired').length}
            </div>
            <div className="text-xs text-muted-foreground">Expired</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-foreground">
              {offers.length}
            </div>
            <div className="text-xs text-muted-foreground">Total</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveOffersManagementCard;